import ng from 'angular';
import { ITrabalhador } from '../../../Trabalhadores/models/trabalhador.model';
import { FluxoAprovacoesService } from '../fluxoaprovacoes.service';
import { IEquipe, IEquipeRequest } from '../models/equipe.model';

export class ModalFluxoAprovacoesController implements ng.IController {

    static $inject = [
        'entity',
        'NewToaster',
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'FluxoAprovacoesService',
    ];

    public busy: boolean = false;
    public form!: ng.IFormController;

    public trabalhadores: ITrabalhador[];
    public gestoresSelecionados: ITrabalhador[] = [];
    public listagemPermissao: string[] | null;

    public nomeEquipe: string = '';
    public equipeMestre: boolean = false;
    public equipe: IEquipeRequest | IEquipe;

    constructor(
        public entity: any,
        public NewToaster: any,
        private $scope: ng.IScope,
        private $rootScope: ng.IRootScopeService & { session: any, nsjGlobals: any },
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private FluxoAprovacoesService: FluxoAprovacoesService
    ) {
        this.entity = ng.copy(this.entity || {});
        if (!Array.isArray(this.entity.usuarios)) {
            this.entity.usuarios = [];
        }

        this.entity.usuarios = (this.entity.usuarios || []).map((usuario: any) => {
            if (typeof usuario === 'string') {
                return { nome: usuario, email: usuario };
            }
            if (!usuario.nome && usuario.email) {
                return { nome: usuario.email, email: usuario.email };
            }
            return usuario;
        });

        if (this.entity.equipefixa) {
            this.entity.mestre = false;
        }
    }

    public confirmar(): void {
        this.form.$submitted = true;

        if (this.form.$invalid) {
            return;
        }

        const usuariosEmails: string[] = (this.entity.usuarios || [])
            .map((u: any) => typeof u === 'string' ? u : u.email)
            .filter((e: any) => !!e);

        if (this.entity.equipe) {
            this.equipe = Object.assign({}, this.entity, {
                usuarios: usuariosEmails,
                mestre: this.entity.equipefixa ? false : this.entity.mestre,
            });
        } else {
            this.equipe = {
                titulo: this.entity.titulo,
                mestre: this.entity.equipefixa ? false : this.entity.mestre,
                descricao: this.entity.descricao,
                usuarios: usuariosEmails
            };
        }

        this.busy = true;

        this.FluxoAprovacoesService.save(this.equipe, false)
            .then(() => {
                this.$uibModalInstance.close(this.equipe);
            })
            .catch((response: any) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: this.extrairMensagemErro(response)
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public close(): void {
        this.$uibModalInstance.dismiss('fechar');
    }

    public onContaSelecionada(conta: any): void {
        if (!conta) { return; }

        if (!Array.isArray(this.entity.usuarios)) {
            this.entity.usuarios = [];
        }

        const email = typeof conta === 'string' ? conta : (conta.email || '');
        const nome = conta.nome || '';

        const exists = this.entity.usuarios.some((usuario: any) => {
            if (typeof usuario === 'string') { return usuario === email; }
            return (usuario.email && usuario.email === email) || (usuario.nome && usuario.nome === nome);
        });

        if (!exists) {
            const novo = { nome, email } as any;
            this.entity.usuarios = [...this.entity.usuarios, novo];
        }

        this.entity.conta = null;
    }

    private extrairMensagemErro(response: any): string {
        const MENSAGEM_ERRO_PADRAO = 'Não foi possível salvar a equipe. Tente novamente.';

        if (!response || !response.data) {
            return MENSAGEM_ERRO_PADRAO;
        }

        // errors vem antes de message porque, em falha de validação, message é só "Validation Failed"
        const mensagensValidacao = this.coletarMensagensValidacao(response.data.errors);
        if (mensagensValidacao.length) {
            return mensagensValidacao.join(' ');
        }

        if (typeof response.data.message === 'string' && response.data.message.trim()) {
            return response.data.message.trim();
        }

        return MENSAGEM_ERRO_PADRAO;
    }

    // as mensagens de validação chegam aninhadas por campo no payload do form
    private coletarMensagensValidacao(valor: any): string[] {
        if (!valor) {
            return [];
        }

        if (typeof valor === 'string') {
            const mensagem = valor.trim();
            return mensagem ? [mensagem] : [];
        }

        if (Array.isArray(valor)) {
            return valor.reduce(
                (mensagens: string[], item: any) => mensagens.concat(this.coletarMensagensValidacao(item)),
                []
            );
        }

        if (typeof valor === 'object') {
            return Object.keys(valor).reduce(
                (mensagens: string[], chave: string) => mensagens.concat(this.coletarMensagensValidacao(valor[chave])),
                []
            );
        }

        return [];
    }
}
